import React from 'react';
import {
  DollarCircleOutlined,
  CheckOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

// Invoice Status Options
export const INVOICE_STATUS_OPTIONS = [
  { label: 'Unpaid', value: 'UNPAID' },
  { label: 'Paid', value: 'PAID' },
  { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
  { label: 'Cancelled', value: 'CANCELLED' },
];

// Invoice Status Colors
export const INVOICE_STATUS_COLORS = {
  UNPAID: 'orange',
  PAID: 'green',
  PARTIALLY_PAID: 'blue',
  CANCELLED: 'red',
} as const;

// Invoice Status Icons
export const INVOICE_STATUS_ICONS = {
  UNPAID: () => <DollarCircleOutlined />,
  PAID: () => <CheckOutlined />,
  PARTIALLY_PAID: () => <ExclamationCircleOutlined />,
  CANCELLED: () => <CloseCircleOutlined />,
} as const;